import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import {
  PATH_SUPER_ADMINISTRATION,
  PATH_SUPER_ADMINISTRATION_SETTINGS,
  PATH_SUPER_ADMINISTRATION_SETTINGS_INFORMATION,
  PATH_SUPER_ADMINISTRATION_SETTINGS_KEYSTORE,
  PATH_SUPER_ADMINISTRATION_SETTINGS_KEYSTORE_UUID,
  PATH_SUPER_ADMINISTRATION_SETTINGS_LOGS,
  PATH_SUPER_ADMINISTRATION_SETTINGS_PKI,
  PATH_SUPER_ADMINISTRATION_SETTINGS_PKI_ALIAS,
  PATH_SUPER_ADMINISTRATION_SETTINGS_TRUSTSTORE,
  PATH_SUPER_ADMINISTRATION_SETTINGS_TRUSTSTORE_UUID,
  PATH_SUPER_ADMINISTRATION_SETTINGS_USERS,
  PATH_SUPER_ADMINISTRATION_SETTINGS_USERS_LOGIN,
} from "~/modules/superAdministration/constants";
import SuperAdministrationPage from "~/modules/superAdministration/views/SuperAdministrationPage.vue";
import SuperAdministrationSettingsPage from "~/modules/superAdministration/views/SuperAdministrationSettingsPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_SUPER_ADMINISTRATION,
    component: SuperAdministrationPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_ORG),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS,
    redirect: PATH_SUPER_ADMINISTRATION_SETTINGS_INFORMATION,
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_INFORMATION,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_ORG),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_USERS,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_USER),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_USERS_LOGIN,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_WRITE_USER),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_LOGS,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_KEYSTORE,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FEATURE),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_KEYSTORE_UUID,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FEATURE),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_TRUSTSTORE,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FEATURE),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_TRUSTSTORE_UUID,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FEATURE),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_PKI,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FEATURE),
    },
  },
  {
    path: PATH_SUPER_ADMINISTRATION_SETTINGS_PKI_ALIAS,
    component: SuperAdministrationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FEATURE),
    },
  },
];

export default routes;
